/**
 * 配置信息
 */
// ww.xx.baidu.com => baidu.com
const getSecondLevelDomain = hostname => {
  const [top, main] = hostname.split('.').reverse();
  return `${main}.${top}`;
};

const host = location.hostname;
const HOST_BODY =
  process.env.NODE_ENV == 'development' && process.env.VUE_APP_HOST_TYPE
    ? process.env.VUE_APP_HOST_TYPE
    : getSecondLevelDomain(host);
const ENV_PREFIX = process.env.VUE_APP_ENV_TYPE
  ? process.env.VUE_APP_ENV_TYPE
  : '';

let opsUrl = '';
let productReg = /localhost|-dev|-stg|-pre|^192\.168|172\.20|10\.30\.28/;
let isProduct = !productReg.test(host) && process.env.NODE_ENV === 'production';

const opsServerApiUrl = {
  dev: `https://actapi-stg.${HOST_BODY}`, // dev 就用 ip
  stg: `https://actapi-stg.${HOST_BODY}`,
  pre: `https://actapi-pre.${HOST_BODY}`,
  gra: `https://actapi-gra.${HOST_BODY}`,
  prd: `https://actapi.${HOST_BODY}`
};

/* 新的 java 活动服务 url & 小拉账号登录走 java,常规登录走之前的 PHP */
const secondServerApiUrl = {
  dev: `https://hestia-stg.${HOST_BODY}`, // dev 就用 ip
  stg: `https://hestia-stg.${HOST_BODY}`,
  pre: `https://hestia-pre.${HOST_BODY}`,
  gra: `https://hestia-gra.${HOST_BODY}`,
  prd: `https://hestia.${HOST_BODY}`
};

/* 新的 java 会员系统服务 url */
const memberServerApiUrl = {
  dev: `https://aerie-dev.${HOST_BODY}`,
  stg: `https://aerie-stg.${HOST_BODY}`,
  // dev: `http://127.0.0.1:9999`,
  // stg: `http://127.0.0.1:9999`,
  pre: `https://aerie-pre.${HOST_BODY}`,
  gra: `https://aerie-gra.${HOST_BODY}`,
  prd: `https://aerie.${HOST_BODY}`
};

let secondBaseUrl = '';
let memberBaseUrl = '';

let isPro = false; //是否生产环境z

if (/-dev|localhost|^192\.168|172\.20|10|30\.30\.28/.test(host)) {
  opsUrl = opsServerApiUrl.dev;
  secondBaseUrl = secondServerApiUrl.dev;
  memberBaseUrl = memberServerApiUrl.dev;
} else if (/-stg/.test(host)) {
  opsUrl = opsServerApiUrl.stg;
  secondBaseUrl = secondServerApiUrl.stg;
  memberBaseUrl = memberServerApiUrl.stg;
} else if (/-pre/.test(host)) {
  opsUrl = opsServerApiUrl.pre;
  secondBaseUrl = secondServerApiUrl.pre;
  memberBaseUrl = memberServerApiUrl.pre;
} else if (/-gra/.test(host)) {
  opsUrl = opsServerApiUrl.gra;
  secondBaseUrl = secondServerApiUrl.gra;
  memberBaseUrl = memberServerApiUrl.gra;
} else {
  opsUrl = opsServerApiUrl.prd;
  secondBaseUrl = secondServerApiUrl.prd;
  memberBaseUrl = memberServerApiUrl.prd;
  isPro = true;
}
if (process.env.NODE_ENV == 'development' && ENV_PREFIX) {
  opsUrl = opsServerApiUrl[ENV_PREFIX];
  secondBaseUrl = secondServerApiUrl[ENV_PREFIX];
  memberBaseUrl = memberServerApiUrl[ENV_PREFIX];
}
export default {
  baseURL: isProduct ? opsServerApiUrl.prd : opsUrl, // 不可以修改，避免影响线上环境
  secondBaseUrl: isProduct ? secondServerApiUrl.prd : secondBaseUrl, // 不可以修改，避免影响线上环境
  memberBaseUrl: isProduct ? memberServerApiUrl.prd : memberBaseUrl, // 不可以修改，避免影响线上环境
  isPro,
  install(Vue) {
    //添加全局方法
    Vue.prototype.$config = {
      opsUrl: opsUrl
    };
  },
  HOST_BODY
};
